import { Globe, Link2, Lock } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'
import type { AccessType } from '@/features/instructions/types'
import { messagesNow } from '@/i18n'
import { messages } from './messages'

/** Single source of truth for access-type icon + label (Закрытый / По ссылке / В каталоге). */
// `label` — геттер: подпись читается на языке интерфейса в момент обращения.
export const ACCESS_META: Record<AccessType, { icon: LucideIcon; readonly label: string }> = {
  public: {
    icon: Globe,
    get label() {
      return messagesNow(messages).accessPublic
    },
  },
  link: {
    icon: Link2,
    get label() {
      return messagesNow(messages).accessLink
    },
  },
  private: {
    icon: Lock,
    get label() {
      return messagesNow(messages).accessPrivate
    },
  },
}
